module.exports = __webpack_public_path__ + "img/oufu_30x50x10.prt.f2ee2bd1.jpg";